// extracted by mini-css-extract-plugin
module.exports = {"LegalDocuments":"LegalDocuments_LegalDocuments__1YMrV","Headers":"LegalDocuments_Headers__OUGyt","TableWrapper":"LegalDocuments_TableWrapper__1ZrCl"};